import { v4 } from 'uuid';

import { Component } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'apm-toggle-type',
  templateUrl: './toggle-type.component.html',
  styleUrls: ['./toggle-type.component.scss'],
  standalone: false,
})
export class ToggleTypeComponent extends FieldType<FieldTypeConfig> {
  uuid = v4();
}
